import React from "react";

export const IlParrocchialeTermsAndConditionsPage: React.FC = () => {
  const platformName = "il_parrocchiale_web";

  return (
    <div className="min-h-screen flex justify-center">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-3xl w-full">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Termini e Condizioni d'Uso
        </h1>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Oggetto</h2>
          <p>
            I presenti Termini e Condizioni regolano l'uso della piattaforma{" "}
            <strong>{platformName}</strong>, dedicata alla gestione del torneo{" "}
            <strong>Il Parrocchiale</strong> promosso dalla Parrocchia San Luigi di
            Reggio Emilia.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. Registrazione e account</h2>
          <p>
            L'utente si impegna a fornire dati corretti e aggiornati. Le credenziali
            di accesso sono personali e non devono essere condivise. Gli organizzatori
            possono sospendere o limitare l'accesso in caso di uso improprio della
            piattaforma.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Finalita della piattaforma</h2>
          <p>
            La piattaforma e pensata per supportare iscrizioni, gestione delle squadre,
            consultazione di calendari, risultati, classifiche e comunicazioni legate
            al torneo.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Regole di comportamento</h2>
          <p>
            Gli utenti sono tenuti a utilizzare la piattaforma e a partecipare al
            torneo con correttezza, rispetto reciproco e spirito sportivo. Non sono
            ammessi comportamenti offensivi, discriminatori o contrari alle finalita
            educative e comunitarie dell'iniziativa.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Risultati e contenuti</h2>
          <p>
            Risultati, classifiche e informazioni pubblicate sulla piattaforma hanno
            finalita organizzative e informative. Gli organizzatori si riservano la
            possibilita di correggere eventuali errori materiali o aggiornare i dati
            quando necessario.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Disponibilita del servizio</h2>
          <p>
            Pur impegnandosi a mantenere la piattaforma accessibile e aggiornata,
            gli organizzatori non garantiscono la continuita assoluta del servizio e
            non rispondono di eventuali interruzioni dovute a cause tecniche o esterne.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">7. Modifiche</h2>
          <p>
            I presenti Termini possono essere aggiornati in qualsiasi momento per
            esigenze organizzative o normative. Le modifiche avranno efficacia dalla
            loro pubblicazione su questa pagina.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">8. Contatti</h2>
          <p>
            Per chiarimenti relativi alla piattaforma o all'organizzazione del torneo,
            e possibile rivolgersi direttamente agli organizzatori de Il Parrocchiale.
          </p>
        </section>
      </div>
    </div>
  );
};
